import { queryBot2 } from 'boot/axios';
import { calcEmpty } from 'src/model/projects/calculates';
import unescapeSql from 'src/mixins/utils';

export async function savePortfolioItem (item) {
    const { id, key, value } = item;
    if (!key || !id) {
        return;
    }
    await queryBot2(`savePortfolioItem-${key}`, { value, id }).then(() => {
        console.log('upd');
    });
}

export async function savePortfolioUpdate (portfolio) {
    if (!portfolio.title) { portfolio.title = ''; }
    if (!portfolio.isShow) { portfolio.isShow = '0'; }
    if (!portfolio.isCreate) { portfolio.isCreate = '0'; }
    if (!portfolio.limit_p) { portfolio.limit_p = '0'; }
    if (!portfolio.limit_r) { portfolio.limit_r = '0'; }
    if (!portfolio.limit_d) { portfolio.limit_d = '0'; }
    if (!portfolio.limit_m) { portfolio.limit_m = '0'; }
    if (!portfolio.limit_a) { portfolio.limit_a = '0'; }

    portfolio.atClose = !portfolio.atClose || calcEmpty(portfolio.atClose) ? 'NULL' : `'${portfolio.atClose}'`;

    return queryBot2('savePortfolioUpdate', {
        title: unescapeSql(portfolio.title),
        flows_id: JSON.stringify(portfolio.flows_id),
        isShow: portfolio.isShow,
        isCreate: portfolio.isCreate,
        atClose: portfolio.atClos,
        limit_p: portfolio.limit_p,
        limit_r: portfolio.limit_r,
        limit_d: portfolio.limit_d,
        limit_m: portfolio.limit_m,
        limit_a: portfolio.limit_a,
        id: portfolio.id,
    }).then(() => true);
}

export async function savePortfolioInsert () {
    return queryBot2('savePortfolioInsert').then(() => true);
}

export default savePortfolioInsert;
